module.exports = __webpack_public_path__ + "static/media/ctrip-logo-icon.dbd8b705.png";